import { createContext } from 'react';

import { BRANDS } from '~/modules/branding/brands';
import type { Brand } from '~/modules/branding/types';

export const BrandContext = createContext<Brand>(BRANDS.WMG);

BrandContext.displayName = 'BrandContext';
